import { getStore } from '~/mobx/AppStore';
import getSelectedElectionById from './getSelectedElectionById';
import sessionApi from '~/clientApis/sessionApi';

const handleUpdateElection = async (): Promise<() => void> => {
    const { generalSettingsStore } = getStore();
    const { preSelectElectionId, latestElectionId } = generalSettingsStore;

    generalSettingsStore.setIsUpdatingElectionData(true);

    const selectedElection = getSelectedElectionById(preSelectElectionId);
    generalSettingsStore.setSelectedElectionId(preSelectElectionId);
    generalSettingsStore.setSelectedElectionData({ ...selectedElection });

    let isSettingsDisabled = false;
    if (preSelectElectionId !== latestElectionId) {
        isSettingsDisabled = true;
    }
    generalSettingsStore.setIsSettingsDisabled(isSettingsDisabled);

    // Save to session
    await sessionApi.updateSession({
        selectedElectionId: preSelectElectionId,
        isSettingsDisabled,
    });

    const timer = setTimeout(() => {
        generalSettingsStore.setIsUpdatingElectionData(false);
    }, 300);
    return () => clearTimeout(timer);
};

export default handleUpdateElection;
